import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { DishCard } from '@/entities/dish'
import { Offcanvas } from '@/entities/offcanvas'
import { useMenuItemDish } from '@/shared/api/dishes'
import { useRouteOffcanvas } from '@/shared/hooks/use-route-offcanvas'

export const Route = createFileRoute(
  '/_auth/canteen/meal-restrictions/restriction/$restrictionId/allergens/dish/$dishId'
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { isOpen, close } = useRouteOffcanvas('../..')
  const { t } = useTranslation()
  const { dishId } = Route.useParams()
  const { data, isLoading, isError } = useMenuItemDish({ id: dishId })

  return (
    <Offcanvas open={isOpen} onClose={close} title={t('Карточка блюда')}>
      <DishCard dish={data?.item} isLoading={isLoading} isError={isError} />
    </Offcanvas>
  )
}
